<template>
  <sc-render :fields="fields" :emptyMessage="$t('FEATURED_NOTE_DATASOURCE_MESSAGE')">
    <div v-if="rendering.dataSource" class="featured-note">
      <h2 class="featured-note_hidden">{{ $t('FEATURED_NOTE_TITLE') }}</h2>
      <div class="image-container">
        <custom-image :editable="false" :media="fields.mainImage" class="image" size="cloudinary_header_image_xlarge"/>
      </div>
        <div class="details-container">
          <sc-text v-if="hasTitle" :field="hasTitle" :editable="false" tag="h3" class="title"/>
          <p v-if="hasCategories" class="category">{{ categoryName }}</p>
          <sh-button
            :to="noteLink"
            size="medium"
            :fullWidth="false"
            :aria-label="ariaToRead"
          >
            {{ $t('EXPLORE_EVENTS_EVENT_MORE_CTA') }}
          </sh-button>
        </div>
    </div>
  </sc-render>
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue'
import get from '~/helpers/get'
import CustomImage from '../custom-image'
import ScRender from '../sc-render/'


export default {
  name: 'FeaturedNote',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  },
  components: {
    ScRender,
    ScText: Text,
    CustomImage
  },
  computed: {
    hasCategories () {
      return get(this.fields, 'categories')
    },
    hasTitle () {
      return get(this.fields, 'title')
    },
    categoryName () {
      return get(this.fields, ['categories', 0, 'fields', 'title', 'value'], '')
    },
    noteLink () {
      return this.fields.source ? this.fields.source.value : ''
    },
    ariaToRead () {
      const name = this.fields.title ? this.fields.title.value : ''
      return this.$t('FEATURED_NOTE_ARIA', { name })
    }
  }
}
</script>

<style lang="scss" scoped>

$note-shadow: 0 24px 30px -20px rgba($deprecated-grey-xx-dark, .1), 0 10px 60px 0 rgba($deprecated-grey-xx-dark, .15);

.featured-note {
  @include transition-fast;

  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 100%;
  margin: $d-xx-large $d-med $space-060;

  &_hidden {
    clip-path: inset(100%);
    clip: rect(1px 1px 1px 1px); /* IE 6/7 */
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  a {
    text-decoration: none;
  }

  .image-container {
    width: 100%;
    height: 600px;
    min-height: 160px;
    background-color: $color-black;
  }

  .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    opacity: 0.54;
  }

  .details-container {
    width: 100%;
    position: absolute;
    flex-direction: column;
    bottom: 0;
    text-align: center;
    margin: auto;
    padding: $space-050 0 $space-060;

    @include tablet {
      padding: $d-xx-large;
    }
  }

  .title {
    @include font('090');

    max-width: 600px;
    margin: auto;
    color: $color-white;
    padding-bottom: $d-med;
  }

  .category {
    @include font('080');

    font-weight: 600;
    margin-bottom: $space-070;
    color: $color-white;
  }

  .link {
    @include label-med;

    display: block;
    height: 35px;
    width: 135px;
    border-radius: 2px;
    margin: auto;
    background: $color-white;
    color: $color-black;
    line-height: 35px;
    text-decoration: none;
  }
}

</style>
